<script setup lang="ts">
  import { BaseButton } from '@bt/design-system'
  import { cva } from 'class-variance-authority'
  import type { IModal } from '@/components/General/modal/types'

  const props = withDefaults(defineProps<IModal>(), {
    rounded: false,
    fullScreen: true
  })

  const { isDesktop } = useBreakpoints()

  const isOpen = defineModel<boolean>({ default: false })

  const modalBase = computed(() =>
    cva('fixed top-0 size-full pb-2 z-20 m-auto overflow-hidden bg-bt-ui-white lg:!w-184 lg:rounded-3xl inset-x-0', {
      variants: {
        full: {
          true: '',
          false: 'lg:h-auto lg:!top-10'
        }
      }
    })({
      full: props.fullScreen
    })
  )

  const contentBase = computed(() =>
    cva('relative flex h-full flex-col overflow-y-auto', {
      variants: {
        full: {
          true: '',
          false: 'justify-center'
        }
      }
    })({
      full: props.fullScreen
    })
  )

  watch(
    () => isOpen.value,
    (value) => {
      if (value) {
        document.body.classList.add('overflow-hidden-modal')
      } else {
        document.body.classList.remove('overflow-hidden-modal')
      }
    }
  )
</script>

<template>
  <div v-if="isOpen">
    <div :class="modalBase">
      <div class="flex h-full flex-col md:pr-2">
        <div class="flex w-full justify-end p-4">
          <BaseButton
            icon="close"
            type="tonal"
            rounded="full"
            icon-size="md"
            @click="isOpen = false"
          />
        </div>
        <div :class="contentBase">
          <slot />
        </div>
      </div>
    </div>
    <div
      class="fixed left-0 top-0 z-10 size-full bg-black/65"
      @click="isOpen = false"
    />
  </div>
</template>

<style>
  .overflow-hidden-modal {
    overflow: hidden;
  }
</style>
